import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import DramaCard from "@/components/base/DramaCard";
import { dramas } from "@/mocks/dramas";

const topDramas = [...dramas].sort((a, b) => b.heat - a.heat).slice(0, 4);
const restDramas = [...dramas]
  .sort((a, b) => b.rating - a.rating)
  .filter((item) => !topDramas.some((top) => top.id === item.id))
  .slice(0, 4);

export default function TrendingSection() {
  return (
    <section className="mx-auto w-full max-w-content px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="本周热播"
        title="正在被反复讨论的爆料短剧"
        description="热度来自站内播放、收藏与讨论的综合值。点开任意一部，就能看到完整演员表、导演编剧信息与拍摄花絮。"
        action={{ to: "/dramas", label: "进入短剧库" }}
      />

      <div className="mt-9 grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-5">
        {topDramas.map((drama, index) => (
          <DramaCard key={drama.id} drama={drama} rank={index + 1} />
        ))}
      </div>

      <div className="mt-10 rounded-lg border border-background-200 bg-background-100 p-5 md:p-7">
        <div className="flex flex-col gap-1.5 sm:flex-row sm:items-center sm:justify-between">
          <h3 className="font-heading text-lg font-bold text-foreground-950">
            口碑评分前列 · 不踩雷片单
          </h3>
          <Link
            to="/dramas"
            className="whitespace-nowrap text-sm text-primary-600 hover:text-primary-700"
          >
            查看完整口碑榜 →
          </Link>
        </div>
        <div className="mt-5 grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-5">
          {restDramas.map((drama) => (
            <DramaCard key={drama.id} drama={drama} />
          ))}
        </div>
      </div>
    </section>
  );
}